import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Page from 'Common/Layout/Page';
import Section from 'Common/Layout/Section';
import DataTable from 'Common/Table/DataTable';
import ActionButton from 'Common/Buttons/ActionButton';
import BackButton from 'Common/Buttons/BackButton';
import ExportCsvButton from 'Common/Buttons/ExportCsvButton';
import ReasonsCell from '../Components/Reasons/Reasons';
import SummaryRow from '../Components/SummaryRow/SummaryRow';
import SuccessFailure from 'Common/Components/success-failure/SuccessFailure.container';

const schema = [
    { field: 'year', label: 'Year', forDisplay: false },
    { field: 'type', label: 'Type', forDisplay: false },
    { field: 'typeDescription', label: 'TypeDescription', forDisplay: false },
    { field: 'template', label: 'Template', forDisplay: false },
    { field: 'amendmentNumber', label: 'Amendment Number', type: 'number' },
    { field: 'amendmentDate', label: 'Amendment Date', type: 'date' },
    { field: 'amendmentReasons', label: 'Amendment Reasons', component: ReasonsCell, forExport: false },
    { field: 'amendmentId', label: 'Amendment ID', forDisplay: false },
    { field: 'amendmentReasonId', label: 'Amendment Reason ID', forDisplay: false },
    { field: 'amendmentReason', label: 'Amendment Reason', forDisplay: false }
];

function TemplateDetailView({
    amendmentNumber,
    dataSource,
    deleteMessage,
    deleteOutcome,
    exportDataSource,
    infoMessage,
    showAdd,
    showData,
    showDeletePrompt,
    showDelete,
    showEdit,
    showExport,
    templateName,
    type,
    typeDescription,
    year,
    onAddClick,
    onBack,
    onDataLoaded,
    onDeletePromptChange,
    onDeleteClick,
    onEditClick,
}) {
    return (
        <Page title="Amend Contract" fitScreen>
            <Section width="small">
                <Typography variant="h3">{year}, {typeDescription} ({type}), {templateName}</Typography>
            </Section>
            {showData && (
                <Section grow width="small">
                    <DataTable
                        dataSource={dataSource}
                        keyField="amendmentNumber"
                        schema={schema}
                        summary={SummaryRow}
                        onLoad={onDataLoaded}
                    />
                </Section>
            )}
            <Section width="small">
                {deleteMessage && (
                    <SuccessFailure hasResult={true} result={deleteOutcome} successMessage={deleteMessage} failMessage={deleteMessage} />
                )}
                {infoMessage && (
                    <SuccessFailure hasResult={true} result={true} infoMessage={infoMessage} />
                )}
            </Section>
            <Section variant="commands" width="small">
                <Section.Command>
                    <BackButton onClick={onBack} />
                </Section.Command>
                {showExport && (
                    <Section.Command>
                        <ExportCsvButton dataSource={exportDataSource} schema={schema} fileName="amendments.csv" />
                    </Section.Command>
                )}
                {showAdd && (
                    <Section.Command>
                        <ActionButton text="Add Amendment" onClick={onAddClick} />
                    </Section.Command>
                )}
                {showEdit && (
                    <Section.Command>
                        <ActionButton text={`Edit Amendment ${amendmentNumber}`} onClick={onEditClick} />
                    </Section.Command>
                )}
                {showDeletePrompt && (
                    <Section.Command>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showDelete}
                                    onChange={onDeletePromptChange}
                                />
                            }
                            label={`I want to delete amendment ${amendmentNumber}`}
                        />
                    </Section.Command>
                )}
                {showDelete && (
                    <Section.Command>
                        <ActionButton text={`Delete Amendment ${amendmentNumber}`} onClick={onDeleteClick} />
                    </Section.Command>
                )}
            </Section>
        </Page>
    );
}

TemplateDetailView.propTypes = {
    amendmentNumber: PropTypes.number.isRequired,
    dataSource: PropTypes.any.isRequired,
    deleteMessage: PropTypes.string,
    deleteOutcome: PropTypes.bool,
    exportDataSource: PropTypes.any,
    infoMessage: PropTypes.any,
    showAdd: PropTypes.bool,
    showData: PropTypes.bool,
    showDeletePrompt: PropTypes.bool,
    showDelete: PropTypes.bool,
    showEdit: PropTypes.bool,
    showExport: PropTypes.bool,
    templateName: PropTypes.string,
    type: PropTypes.string,
    typeDescription: PropTypes.string,
    year: PropTypes.string,
    onAddClick: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onDataLoaded: PropTypes.func.isRequired,
    onDeletePromptChange: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    onEditClick: PropTypes.func.isRequired,
};

export default TemplateDetailView;